module.exports = __webpack_public_path__ + "static/media/korea-cover.46a2ea9e.webp";